import { useMemo } from 'react'

import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import type { RootState } from '@store/rootReducer'

import { useDecodedAccessToken } from '../AuthProvider'

type OptionalUserInfo = {
  accountId?: string
  personId?: string
}

function useUserInfo(opts?: { required?: false }): OptionalUserInfo
function useUserInfo(opts: { required: true }): Required<OptionalUserInfo>
function useUserInfo({ required }: { required?: boolean } = {}) {
  const params = useParams<OptionalUserInfo>()
  const { accountId: storeAccountId, personId: storePersonId } =
    useDecodedAccessToken() ?? {}

  // During registration, user info may exist in signup state before login
  const { accountId: signupAccountId, _id: signupPersonId } = useSelector(
    ({ auth }: RootState) => auth.signup.submitEmail
  )

  const accountId = params.accountId || storeAccountId || signupAccountId
  const personId = params.personId || storePersonId || signupPersonId

  if (required && (!accountId || !personId)) {
    throw new Error(
      'accountId and/or personId could not be determined, but was required'
    )
  }

  return useMemo(
    () => ({
      accountId,
      personId,
    }),
    [accountId, personId]
  )
}

export default useUserInfo
